export const MINIMUM_CREATE_CONTEXT_HINT =
    'Add a creative, a URL, or products to start.'

export function hasDeeplinkUrl(
    referenceUrl?: string | null,
    productUrl?: string | null,
): boolean {
    return Boolean(referenceUrl?.trim() || productUrl?.trim())
}

export function hasMinimumCreateContext(input: {
    hasCreative: boolean
    hasDeeplinkUrl: boolean
    hasProducts: boolean
}): boolean {
    return input.hasCreative || input.hasDeeplinkUrl || input.hasProducts
}

export function submitButtonTooltip(
    isSubmitting: boolean,
    canSubmit: boolean,
): string {
    if (isSubmitting) return 'Starting build…'
    if (canSubmit) return 'Start build'
    return MINIMUM_CREATE_CONTEXT_HINT
}

export function shouldShowContextHint(
    hasMinimumContext: boolean,
    isSubmitting: boolean,
): boolean {
    return !hasMinimumContext && !isSubmitting
}
